import React, { useEffect, useState } from "react";
import { UsuariosAdapter } from "../../../../../infraestructure/persistence/rest/UsuariosAdapter";
import { useNotifications } from "../../../../../shared/hooks/Notifications";
import { ServerErrorMessage } from '../../../../../shared/utils/error';
import { ConfiguracionDatosUsuarioScreen } from "./screen";


export const ConfiguracionMisDatosUsuarioContainer= (props) =>{

    const {user,setUser} = props
    const api = new UsuariosAdapter();
    const {resultError, exceptionError, launchNotification} = useNotifications();
    const [ datos, setDatos ] = useState(undefined);
    let [isLoading, setIsLoading] = useState(false)
    let result;
  
    useEffect(() => {getDatosUserConfig()}, []);
  
    const getDatosUserConfig = async () => {
        setIsLoading(true);
      try {
        result = await api.GetDatosUsuario();
        if(result.data && result.data!=="")
        {
          setDatos(result.data[0] || undefined);
          setIsLoading(false);
        }else{resultError();setIsLoading(false);}
      } catch (error) {
        let exception = ServerErrorMessage(error);
        exceptionError(exception)
        setIsLoading(false);
      }
    };

    const Save = async (validadorAS400) => {
      try {
        result = await api.GuardarValidadorAS400(validadorAS400);
        if(result.data && result.data!=="")
        {
          //setDatos(result.data[0] || undefined);
          setUser({...user,...{validadorAS400:validadorAS400}})
          launchNotification({type:"success",title:"Asignación de validador AS400",message:"Se ha guardado la asignación de un validador para las afcturas de exaptriados."})
        }else{resultError()}
      } catch (error) {
        let exception = ServerErrorMessage(error);
        exceptionError(exception)
      }
    };


    return datos!==undefined ? (<ConfiguracionDatosUsuarioScreen data={datos} onSave={Save} isLoading={isLoading} user={user}/>) : null
 
}
export default ConfiguracionMisDatosUsuarioContainer;